
// AONIC: Defer autoplay video loading until near viewport
(function() {
  function deferAutoplayVideos() {
    var deferredMediaEls = document.querySelectorAll('deferred-media[autoplay]');
    if (!deferredMediaEls.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          // Find the video inside template and move it out to trigger load
          var template = el.querySelector('template');
          if (template) {
            var clone = template.content.cloneNode(true);
            el.appendChild(clone);
          }
          // Also trigger the native showDeferredMedia if available
          if (typeof el.showDeferredMedia === 'function') {
            el.showDeferredMedia();
          }
          observer.unobserve(el);
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0 });

    deferredMediaEls.forEach(function(el) {
      // Remove the eagerly loaded video src to prevent immediate download
      var videos = el.querySelectorAll('video:not(template video)');
      videos.forEach(function(v) {
        // Pause and remove src to stop loading
        v.pause();
        var sources = v.querySelectorAll('source');
        sources.forEach(function(s) {
          s.dataset.src = s.src;
          s.removeAttribute('src');
        });
        v.load(); // abort current load
      });
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferAutoplayVideos);
  } else {
    deferAutoplayVideos();
  }
})();
